/* Ritual's signup events. This adapter never reads input values.
 * The production loader must explicitly permit analytics before any listener runs.
 * Stored timestamps/flags suppress reload duplicates, never establish signup success.
 */
(function () {
  'use strict';
  if (!window.RitualAnalyticsEnabled || window.RitualAnalyticsEvents) return;
  var started = new WeakSet();
  var ttl = 30 * 60 * 1000;
  var memory = {};
  var confirmed = null;
  var successSettled = true;
  var afterSuccess = function () {};

  function position(element) {
    if (element.closest('.r21-header')) return 'header';
    if (element.closest('.r21-floating-access')) return 'floating';
    if (element.closest('.r21-hero')) return 'hero';
    if (element.closest('.r21-circle')) return 'circle';
    return null;
  }
  function read(place) {
    var record = memory[place];
    try {
      record = JSON.parse(window.sessionStorage.getItem('ritual.analytics.' + place)) || record;
    } catch (_) {}
    return record && Date.now() - record.at < ttl && record.at <= Date.now() ? record : null;
  }
  function save(place, record) {
    memory[place] = record;
    try { window.sessionStorage.setItem('ritual.analytics.' + place, JSON.stringify(record)); } catch (_) {}
  }
  function emit(name, place, callback) {
    var finished = false;
    function done() {
      if (finished) return;
      finished = true;
      if (callback) callback();
    }
    try {
      if (typeof window.plausible !== 'function') { done(); return; }
      window.plausible(name, { props: { location: place }, callback: done });
    } catch (_) { done(); }
  }

  // Delegation survives Shopify section replacement without duplicate listeners.
  document.addEventListener('click', function (event) {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    var control = event.target.closest('.r21-header__cta, .r21-nav-access, .r21-floating-access, .r21-form button[type="submit"]');
    var place = control && position(control);
    if (place) emit('Early Access Click', place);
  });
  document.addEventListener('input', function (event) {
    if (!event.isTrusted || !(event.target instanceof Element) || !event.target.matches('input[type="email"]')) return;
    var form = event.target.closest('form.r21-form');
    var place = form && position(form);
    if (!place || started.has(form)) return;
    started.add(form);
    emit('Waitlist Form Start', place);
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!event.isTrusted || !(form instanceof HTMLFormElement) || !form.matches('.r21-form')) return;
    var place = position(form);
    if (place && form.checkValidity()) save(place, { at: Date.now(), success: false });
    // Never cancel, replay, change native form data, or infer success here.
  }, true);

  var markers = Array.from(document.querySelectorAll('[data-ritual-signup-confirmed]'));
  var fragment;
  try { fragment = decodeURIComponent(window.location.hash.slice(1)); } catch (_) { fragment = ''; }
  confirmed = markers.find(function (marker) {
    var form = marker.closest('form');
    return form && form.id === fragment;
  }) || markers[0] || null;
  var place = confirmed && position(confirmed);
  var receipt = place && (read(place) || { at: Date.now(), success: false });
  if (receipt && !receipt.success) {
    receipt.success = true;
    save(place, receipt);
    successSettled = false;
    emit('Waitlist Signup Success', place, function () {
      successSettled = true;
      afterSuccess();
    });
  }

  window.RitualAnalyticsEvents = {
    afterSignup: function (navigate) {
      // Every confirmed form uses the same destination. Wait for the selected
      // signup event even when Shopify renders success on more than one form.
      if (!confirmed || !receipt || successSettled) { navigate(); return; }
      var finished = false;
      function finish() {
        if (finished) return;
        finished = true;
        window.clearTimeout(timer);
        navigate();
      }
      // Blocked collectors and callbacks that never arrive cannot trap the signup.
      var timer = window.setTimeout(finish, 700);
      afterSuccess = finish;
    }
  };
}());
